import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalComponent } from '../../global-component';
import { CurrentUser } from '../models/currentuser.models';
import { Observable } from 'rxjs';
import { TokenStorageService } from './token-storage.service';

const BASE_URL = GlobalComponent.BASE_API_URL;
@Injectable({ providedIn: 'root' })

/**
 * Salesproposal-service Component
 */
export class SalesproposalService {

  firbasebasecollname: string = 'vendors';
  currentuser!: CurrentUser;
  firebaseclientcollname: string = 'clients';

  constructor(private http: HttpClient, private tokenService: TokenStorageService) {
    this.currentuser = this.tokenService.getCurrentUser();
  }

  /**
   * ADD SALESPROPOSAL RECORD API
   */
  addSalesproposalsData(postdata: any) : Observable<any>{
    return this.http.post<any>(BASE_URL + GlobalComponent.salesproposalsGet, postdata);
  }

  /**
   * GET SALESPROPOSAL RECORD API
   * fetch record on basis of record guid
   */
  getSalesproposalsRecordData(recordguid: string) : Observable<any> {
    console.log("fetching salesproposal data");
    return this.http.get<any>(BASE_URL + 'salesproposal/details/' + recordguid);
  }

  /**
   * UPDATE SALESPROPOSAL STATUS
   */
  updateSalesproposalStatus(recordguid: string, postdata: any) : Observable<any>{
    return this.http.put<any>(BASE_URL + 'salesproposal/update/' + recordguid,  {data: postdata});
  }

  /**
   * GET SALESPROPOSAL MEMBERS LIST
   */
  getSalesproposalsMembersList(recordguid: string) : Observable<any[]> {
    console.log("fetching salesproposal members list");
    return this.http.get<any[]>(BASE_URL + 'salesproposal/memberlist/' + recordguid);
  }

  /**
   * CANCEL SALESPROPOSAL PROJECT
   */
  cancelSalesproposalProject(postdata: any) : Observable<any>{
    return this.http.post<any>(BASE_URL + 'salesproposalcancels', {data: postdata});
  }

  /**
   * GET SALESPROPOSAL ATTACHMENTS
   */
  getSalesproposalsAttachments(recordguid: string) : Observable<any[]> {
    console.log("fetching salesproposal attachments list");
    return this.http.get<any[]>(BASE_URL + 'salesproposalattachments/attachments/'+recordguid);
  }

  /**
   * UPDATE PLANSET RECORD API
   */
  editSalesproposalsData(postdata: any, recordId: number) : Observable<any>{
    return this.http.put<any>(BASE_URL + GlobalComponent.salesproposalsGet + '/' + recordId, postdata);
  }

  /**
   * RELEASE RECORD
   */
  releaserecord(jobguid: string, postdata: any) {
    return this.http.put<any>(BASE_URL + 'salesproposal/releaserecord/' + jobguid, {data: postdata});
  }

   /**
   * GET PLANSET FILE ATTACHMENT TO DOWNLOAD FILE
   */
  getSalesproposalFile(recordguid: string) : Observable<any[]> {
    return this.http.get<any[]>(BASE_URL + 'salesproposalattachments?filters[activestate][$eq]=true&filters[fieldname][$eq]=salesproposalfile&filters[jobguid][$eq]='+recordguid+'&populate=*');
  }

  /**
   * DELETE LATEST REVISION
   */
  deleterevision(id: number) {
    return this.http.put<any>(BASE_URL + 'salesproposalrevisionjobs/' + id, { data: { activestate: false }});
  }

}